//---------- vendor libraries ----------
import 'jquery';
import './Libs/jquery.migrate.min.js';
import './Libs/jquery.cookie';
import './Libs/fastclick';
// import './Libs/foundation-new/foundation.js'
import './Libs/foundation.min'; // <- todo: this is huge, it would be great to only use what's needed...
// import './Libs/foundation-new/foundation.js'
import './Libs/jquery.calendario';
import {PhoneNumberMask} from "./Components/phone-number-mask";
import {Utils} from "./Components/Utils";
//import './Libs/slick.min'; // <- not currently being used
// import './Libs/foundation-new/plugins/foundation.core'
// import './Libs/foundation-new/plugins/foundation.offcanvas'
// window.$ = window.jQuery = require('jquery');
import "loadjs/dist/loadjs.min";

import MicroModal from 'micromodal';

window.initMicroModal = function(){
    MicroModal.init({
        onClose: modal => {
            $('.yt-iframe').attr('src', '');
        },
    });
}

window.initMicroModal();

// Add global function to initialise the gallery with library Splide
window['initSlideGallery'] = function (slideSelector, thumbnailSelector = '#splide-thumbnails'){
    let enableThumbs = false;
    let thumbnails;

    const main = new Splide( slideSelector, {
        type      : 'fade',
        rewind    : true,
        pagination: false,
        arrows    : false,
        fixedHeight: 409,
        lazyLoad: 'sequential'
    } );

    if(document.querySelector(thumbnailSelector)) {
        enableThumbs = true;
    }

    if(enableThumbs){
        thumbnails = new Splide( thumbnailSelector, {
            fixedWidth  : 100,
            fixedHeight : 60,
            gap         : 10,
            rewind      : true,
            pagination  : false,
            isNavigation: true,
            padding: { left: 55, right: 55 },
            lazyLoad: 'sequential',
            breakpoints : {
                600: {
                    fixedWidth : 60,
                    fixedHeight: 44,
                },
            },
        } );

        main.sync( thumbnails );
    }

    main.mount();

    if(enableThumbs){
        thumbnails.mount();
    }

    return main;
}

import UIKit from 'uikit';

//kick off foundation
$(function () {
    $(document).foundation();
});

/**
 * Add an utility method to check if a value exists
 * @returns {boolean}
 */
$.fn.exists = function () {
    return this.length !== 0;
}

//---------- custom component scripts ----------
import './Components/calendar';
import './Components/cart';
import './Components/cartFooter';
import './Components/products';
import './Components/alert';
import './Components/NewsletterPopup';
//import './Components/productCarousel'; // <- not currently being used
import './Components/profile';
import './Components/schedule';
import './Components/phone-number-mask';
import {NewsletterPopup} from "./Components/NewsletterPopup";
//import './Components/_FULL_payment'; // <- not currently being used

// Modules
import {search} from './modules/search'  

$(function () {

    // Init header search forms
    search.init();

    // allows a new tab type in the product / classes tabs
    // that will redirect the user to a static link
    const $hardlinks = $('.tab-title > a[data-hardlink]');
    $hardlinks.each(function () {
        const $link = $(this);
        $link.on('click', function () {
            window.location = $link.data('hardlink');
        });
    });




    const $productVariantSelect = $('#product-variant-select');
    // const $productImage = $('#product-image');
    const $productSlideContainer = $('#product-slide-container');
    if ($productVariantSelect) {
        let ajaxData = {};
        ajaxData[window.csrfTokenName] = window.csrfTokenValue;

        $productVariantSelect.on('change', function(){
            const val = $productVariantSelect.val();

            $('.product-price-row').each(function(){
                const $row = $(this);
                const img = $row.data('img');
                if($row.data('id') == val){
                    ajaxData['product'] = $row.data('product-slug');
                    ajaxData['variant'] = val;
                    $.ajax({
                        method: 'GET',
                        url: '/actions/montavilla/gallery/get-product-gallery',
                        data: ajaxData,
                        success: function(result){
                            $productSlideContainer.html(result);
                            window.productGallery.destroy(true);
                            const splide = window.initSlideGallery('#splide-gallery');
                            window['productGallery'] = splide;
                        }
                    })
                    $row.show();
                    // if(img){
                    //     $productImage.attr('src', img);
                    // }
                } else {
                    $row.hide();
                }
            });
        });
    }


    /** Open url rows in new tab:
     * On the "/instructors-only" page
     * there are rows that will open in a new tab.
     * This will help open them in a new tab
     * since links don't play well with tables
     *
     */
    $('tr[data-url]').on('click', function() {
        var url = $(this).data('url');
        if (url) {
            window.open(url, '_blank').focus();
        }
    });

    $(document).on('click', '.js-go-to-url', function (e) {
        const url = $(this).data('url');

        if(e.target.nodeName !== "A" && e.target.nodeName !== "BUTTON"){
            window.location.href = url;
        }
    })

    /*
    * Update via ajax the cart icon badge count on each page refresh
    * */
    window.cart.updateShoppingCartBadgeTotalQty();

    const phoneMask = new PhoneNumberMask();
    phoneMask.addMaskToClass('js-masked-phone-number', true);

    // Initialize newsletter popup class
    const newsletterPopup = new NewsletterPopup();
    newsletterPopup.init();

   $('#announcement-banner-close-button').on('click', function(e){
      $('#announcement-banner').fadeOut(500);
      jQuery.cookie('announcementBannerDismissed', 'true');
   });
});




